/**
 * Fellheimat - Warenkorb-Reservierung: Countdown in der Kopfzeile des Drawers
 *
 * WAS ER TUT
 * Jeder Add-to-Cart setzt die Uhr auf MINUTES (Vorgabe 10) zurueck - egal ob
 * der Drawer offen ist oder nicht. Der Endzeitpunkt liegt im localStorage,
 * damit die Uhr im Hintergrund weiterlaeuft: Seite wechseln, Drawer schliessen,
 * Tab wechseln - alles egal, beim naechsten Oeffnen steht der richtige Rest.
 * Ist die Zeit abgelaufen (oder es gab noch nie einen Add-to-Cart), bleibt
 * die Pille unsichtbar. Am Warenkorb selbst aendert der Ablauf nichts.
 *
 * WIE DER ADD-TO-CART ERKANNT WIRD
 * fetch-Patch, der NUR beobachtet: jede erfolgreiche Antwort auf /cart/add(.js)
 * startet die Uhr neu. Dieses Skript wird als LETZTES im <head> geladen
 * (snippets/stylesheets.liquid rendert fh-cart-timer-config nach
 * fh-free-gift-config) und ist damit der AEUSSERSTE Patch:
 *     fh-volume-tiers.js -> fh-cart-timer.js -> fh-free-gift.js -> fh-shield.js -> fetch
 * Das ist Absicht: fh-shield.js und fh-free-gift.js schicken beim Umbau des
 * Warenkorbs eigene add.js-Requests ueber ihr jeweils gemerktes nativeFetch -
 * die laufen an diesem Patch VORBEI und starten die Uhr nicht. Nur echte
 * Klicks des Kunden (Produktseite, Mengenstaffel, Quick-Add im Drawer) kommen
 * ueber window.fetch hier an.
 *
 * WIE DIE ANZEIGE LEBT
 * <fh-cart-timer> ist ein Custom Element (snippets/fh-cart-timer). Es tickt,
 * solange es im DOM haengt, und hoert auf, sobald Horizon den Drawer neu
 * rendert und den Knoten entfernt - das naechste Exemplar startet von selbst.
 * Das Element traegt data-skip-node-update, damit Horizons Morph den vom
 * Skript geschriebenen Text nicht mit dem Server-Platzhalter ueberschreibt.
 */
(function () {
  'use strict';

  var CFG = window.FH_CART_TIMER || {};
  var MINUTES = Number(CFG.minutes) > 0 ? Number(CFG.minutes) : 10;
  var KEY = 'fh_cart_timer_end';
  var EVENT = 'fh:cart-timer';
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  /* Rueckfall fuer den privaten Modus: dann gilt die Uhr nur fuer diese Seite. */
  var memoryEnd = 0;

  function readEnd() {
    try {
      var v = Number(window.localStorage.getItem(KEY));
      return v > 0 ? v : memoryEnd;
    } catch (e) {
      return memoryEnd;
    }
  }

  function writeEnd(value) {
    memoryEnd = value;
    try {
      window.localStorage.setItem(KEY, String(value));
    } catch (e) {
      /* privater Modus */
    }
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { end: value } }));
  }

  function restart() {
    writeEnd(Date.now() + MINUTES * 60 * 1000);
  }

  function format(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* FARBE: gruen -> gelb-orange -> rot, je weiter die Zeit ablaeuft.
     Fortschritt p = abgelaufener Anteil der Laufzeit (0 = frisch gestartet,
     1 = abgelaufen). Der Farbton laeuft in zwei linearen Stuecken durch das
     Spektrum: 95 (Salbei, Markenfarbe) -> 45 (Gelb-Orange) bei halber Zeit
     -> 10 (Rot) am Ende. Die Saettigung steigt von 18 % (gedeckt, passt zum
     warmen Theme) auf 62 % - Gruen bleibt ruhig, Rot wird dringlich. Beides
     landet als CSS-Variable am Element; das Stylesheet in
     snippets/fh-cart-timer mischt daraus Hintergrund, Icon und Zahl und
     blendet per transition weich von Tick zu Tick. */
  function tone(rest) {
    var total = MINUTES * 60 * 1000;
    var p = 1 - rest / total;
    if (p < 0) p = 0;
    if (p > 1) p = 1;
    var hue = p < 0.5 ? 95 - (95 - 45) * (p / 0.5) : 45 - (45 - 10) * ((p - 0.5) / 0.5);
    var sat = 18 + (62 - 18) * p;
    return { hue: Math.round(hue), sat: Math.round(sat) };
  }

  /* --- Anzeige --------------------------------------------------------------- */

  class FhCartTimer extends HTMLElement {
    connectedCallback() {
      this._tick = () => this.tick();
      document.addEventListener(EVENT, this._tick);
      window.addEventListener('storage', this._tick);
      this.tick();
      /* 250 ms, damit der Sekundenwechsel ohne sichtbaren Verzug ankommt. */
      this._interval = window.setInterval(this._tick, 250);
    }

    disconnectedCallback() {
      window.clearInterval(this._interval);
      document.removeEventListener(EVENT, this._tick);
      window.removeEventListener('storage', this._tick);
    }

    tick() {
      var rest = readEnd() - Date.now();
      if (rest <= 0) {
        if (!this.hidden) this.hidden = true;
        return;
      }
      var text = format(rest);
      var value = this.querySelector('[data-fh-timer-value]');
      if (value && value.textContent !== text) value.textContent = text;
      var t = tone(rest);
      if (this._hue !== t.hue || this._sat !== t.sat) {
        this._hue = t.hue;
        this._sat = t.sat;
        this.style.setProperty('--fh-timer-h', String(t.hue));
        this.style.setProperty('--fh-timer-s', t.sat + '%');
      }
      if (this.hidden) this.hidden = false;
    }
  }

  if (window.customElements && !window.customElements.get('fh-cart-timer')) {
    window.customElements.define('fh-cart-timer', FhCartTimer);
  }

  /* --- fetch-Patch (nur beobachten) ------------------------------------------ */

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input) {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(null, args);

    if (CART_ADD.test(url)) {
      promise
        .then(function (res) {
          if (res && res.ok) restart();
        })
        .catch(function () {});
    }

    return promise;
  };
})();
